/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el     = $(el);
const $iframe = $el.find('.iframe-faq');

// $iframe.on('load', function () {
    // const $this = $(this);
    // console.log($this.height());
    // const height = $this.contents().find('html').height();

    // console.log(height);
// });